<template>
   <div id="Contract" class="fit q-px-md">
            <crud-layout-search
              :ref="'crudLayoutSearch'"
              :name="$gettext('PERSON_CONFIRMATION_DATA')"
              :interface="nmInterface"
              :id="id"
              clean-layout
            >
              <page-table
                slot="page-table"
                slot-scope="dataPageTable"
                v-bind="dataPageTable"
                @action-button="dataPageTable.actionButton"
                @show-message="dataPageTable.showMessage"
              >
                <jt-data-table
                  slot="table"
                  slot-scope="dataTable"
                  v-bind="dataTable"
                  singleselect
                  class="table-crud"
                  :row-buttons="true"
                  @selection="dataTable.selection"
                  @action-button="markAnalyzed"
                  @show-message="dataTable.showMessage"
                  @toggle-change="row"
                >
                </jt-data-table>
              </page-table>
            </crud-layout-search>
          </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDataTable } from 'jtech-webcomps'
import { repository } from 'jtech'
const { CrudLayoutSearch, pageTable } = JtCrud

@Component({
  name: 'PersonConfirmationData',
  components: {
    CrudLayoutSearch,
    pageTable,
    JtDataTable
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class PersonConfirmationData extends Vue {
  get nmInterface () {
    return this.interface
  }

  async markAnalyzed (button, row) {
    await repository.resolveLogic('personConfirmationData.markAnalyzed', { id: row.id })
    this.$refs.crudLayoutSearch.refresh()
  }
}
export default PersonConfirmationData
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

#MtrComponentGroup {
.buttons-top-crud{
    margin-top: 5px;
    margin-bottom: -3px;
  }

::v-deep {
  .jt-crud-container {
    padding: 0%;
  }
}

.padding-crud{
     padding: 0px 10px 10px;
     margin-top: -15px;
   }

    .itemSelect{
     color: white;
     background: $secondary!important;
     border-left: 5px solid $dark!important;
     padding-left: 5%!imporant;
   }

   .item{
     background: white;
     font-weight: 500;
     padding-left: 10%;
     font-size: 1rem;
   }
 }
</style>
